import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ZenithToastComponent } from './zenith-toast/zenith-toast.component';
import { NotificationComponent } from './notification/notification.component';
import { ZenithTextareaFormGroupComponent } from './form/zenith-textarea-form-group/zenith-textarea-form-group.component';
import { CustomZenithSimpleSelectComponent } from './form/custom-zenith-simple-select/custom-zenith-simple-select.component';
import { CustomZenithFormGroupErrorComponent } from './form/custom-zenith-form-group-error/custom-zenith-form-group-error.component';
import { InvalidAsyncPipe } from '../../shared/pipes/invalid-async.pipe';

/**
 * @deprecated use standalone components for Zenith instead.
 */
@NgModule({
  declarations: [
    CustomZenithSimpleSelectComponent,
    ZenithTextareaFormGroupComponent,
    NotificationComponent,
    ZenithToastComponent
  ],
  exports: [
    CustomZenithSimpleSelectComponent,
    ZenithTextareaFormGroupComponent,
    NotificationComponent,
    ZenithToastComponent,
    CustomZenithFormGroupErrorComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    ZenithComponentsModule,
    CustomZenithFormGroupErrorComponent,
    InvalidAsyncPipe
  ]
})
export class ZenithCustomComponentsModule {}
